(function () {
    'use strict';

    angular
        .module('travelExpenses')
        .controller('DailyAllowanceController', DailyAllowanceController);

        DailyAllowanceController.$inject = ['$state', '$uibModal','toastr', 'TravelExpenseService', 'ExpoService', 'SellerService', 'InvoicesService'];
    function DailyAllowanceController($state, $uibModal, toastr, TravelExpenseService, ExpoService, SellerService, InvoicesService) {
        
        var vm = this;
        vm.expoSelected           = '';
        vm.sellerSelected         = '';
        vm.currencySelected       = '';

        // Methods
        vm.selectSellers          = selectSellers;
        vm.selectExpos            = selectExpos;
        vm.selectCurrencies       = selectCurrencies;
        vm.getByFilter            = getByFilter;
        vm.createDailyAllowance   = createDailyAllowance;
        vm.editDailyAllowance     = editDailyAllowance;
        vm.deleteDailyAllowance   = deleteDailyAllowance;
        vm.flag                   = false;

        vm.selectOptionAll        = [{id: -1, name: '--- All ---'}];

        /*PAGINATION*/
        vm.pageChanged            = pageChanged;
        vm.setPage                = setPage;
        vm.totalItems             = [];
        vm.to                     = [];
        vm.currentPage            = null;
        vm.itemsPerPage           = [];
        vm.page                   = 1;

        function activate() {
            vm.selectSellers();
            vm.selectExpos();
            vm.selectCurrencies();
            vm.getByFilter();
        }

        function selectSellers() {
            SellerService.getStaff().then(function(response) {
                vm.sellers = vm.selectOptionAll.concat(response.data);
            }).catch(function(err) {
            });
        }

        function selectExpos () {
            ExpoService.getExpos().then(function(response){
                vm.expos = vm.selectOptionAll.concat(response.data);
            }).catch(function(err) {
            });
        }

        function selectCurrencies () {

            InvoicesService.getPaymentCurrencies().then(function (response) {
                vm.currencies = response.data;
            });

            // CurrencyService.getCurrencies().then(function(response){
            //     vm.currencies = response.data;
            // }).catch(function(err) {
            // });
        }

        function getByFilter() {
            vm.flag = false;
            let query = {};
            if(vm.expoSelected != '') {
                query['expo_id'] = vm.expoSelected;
            }
            if(vm.sellerSelected != '') {
                query['seller_id'] = vm.sellerSelected;
            }
            TravelExpenseService.getDailyAllowance(query).then(function(response){
                vm.flag = true;
                vm.results = response.data.data;
                vm.totalItems = response.data.total;
                vm.to = response.data.to;
                vm.setPage(response.data.current_page);
                vm.itemsPerPage = response.data.per_page;
            }).catch(function(err) {
            });
        }

        function createDailyAllowance() {
            $uibModal.open({
                templateUrl: 'templates/travelexpenses/dailyallowance/create/form.modal.html',
                controller: 'DailyAllowanceFormModalController',
                controllerAs:'dailyAllowanceFormModal',
                size: 'lg',
                resolve: {
                    sellers: function () {
                        return vm.sellers
                    },
                    expos: function () {
                        return vm.expos
                    },
                    currencies: function () {
                        return vm.currencies
                    },
                    dailyAllowanceController: function () {
                        return vm
                    }
                }
            });
        }

        function editDailyAllowance(item) {
            $uibModal.open({
                templateUrl: 'templates/travelexpenses/dailyallowance/edit/form.modal.html',
                controller: 'DailyAllowanceEditModalController',
                controllerAs:'dailyAllowanceEditModal',
                size: 'lg',
                resolve: {
                    item: function () {
                        return item
                    },
                    sellers: function () {
                        return vm.sellers
                    },
                    expos: function () {
                        return vm.expos
                    },
                    currencies: function () {
                        return vm.currencies
                    },
                    dailyAllowanceController: function () {
                        return vm
                    }
                }
            });
        }

        function deleteDailyAllowance(item) {
            $uibModal.open({
                templateUrl: 'templates/travelexpenses/dailyallowance/delete/template.modal.html',
                controller: 'DailyAllowanceDeleteModalController',
                controllerAs:'dailyAllowanceDeleteModal',
                resolve: {
                    item: function () {
                        return item
                    },
                    dailyAllowanceController: function () {
                        return vm
                    }
                }
            });
        }

        function setPage (pageNo) {
            vm.currentPage = pageNo;
        }

        function pageChanged (pageNo) {
            vm.page = vm.currentPage;
            vm.getByFilter();
        }

        activate();
    }

})();